import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Using Theme UI without MDX"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "using-theme-ui-without-mdx"
    }}>{`Using Theme UI without MDX`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`theme-ui`}</inlineCode>{` package supports treeshaking, and can generally be used with or without MDX.
If you'd like finer-grained control over your application's bundle and do not need to use MDX, you can install the `}<inlineCode parentName="p">{`@theme-ui/core`}</inlineCode>{` package instead.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/core
`}</code></pre>
    <p>{`This package includes only a subset of the features of Theme UI and lacks support for MDX, color modes, and base global styles.
Use the JSX functions and `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component from this package for a bare-bones Theme UI setup.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      